// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3Dpxu","calendarButtons":"ClockData_calendarButtons__Evl-H"};